module.exports = __webpack_public_path__ + "img/bg.964fc9a4.jpg";